import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { loadConfig } from "./config";
import { BrandingProvider } from "@/components/branding/BrandingProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 2 * 60 * 1000, // 2 minutes default
      gcTime: 5 * 60 * 1000, // 5 minutes default
    },
  },
});

export function App() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadConfig()
      .then(() => setReady(true))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load config"));
  }, []);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-danger">{error}</p>
      </div>
    );
  }

  if (!ready) {
    return <div className="flex h-screen items-center justify-center">Loading...</div>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <RouterProvider router={router} />
      </BrandingProvider>
    </QueryClientProvider>
  );
}
